export const navItems = [
  {
    id: 1,
    title: "ABOUT US",
    path: "./aboutus",
    cName: "nav-item",
  },
  {
    id: 2,
    title: "CUSTOMERS",
    path: "./customer",
    cName: "nav-item",
  },
  {
    id: 3,
    title: "SUPPLIERS",
    path: "./suppliers",
    cName: "nav-item",
  },
  {
    id: 4,
    title: "CAREERS",
    path: "./careers",
    cName: "nav-item",
  },
  {
    id: 5,
    title: "FULLFILMENT SERVICES",
    path: "./services",
    cName: "nav-item",
  },
];

export const aboutDropdown = [
  {
    id: 1,
    title: "LOCATIONS",
    path: "./locations",
    cName: "submenu-item",
  },
  {
    id: 2,
    title: "ESSANDANT LEADERSHIP",
    path: "./leadership",
    cName: "submenu-item",
  },
  {
    id: 3,
    title: "OUR HISTORY",
    path: "./history",
    cName: "submenu-item",
  },
];
export const customerDropdown = [
  {
    id: 1,
    title: "MARKETING AND DIGITAL SERVICES",
    path: "./mdservices",
    cName: "submenu-item",
  },
  {
    id: 2,
    title: "RESSELER TOOLS",
    path: "./resseler",
    cName: "submenu-item",
  },
  {
    id: 3,
    title: "FOR EXISTING CUSTOMERS",
    path: "./existingcustomer",
    cName: "submenu-item",
  },
  {
    id: 4,
    title: "PRODUCT CATEGORY",
    path: "./procategory",
    cName: "submenu-item",
  },
];
export const serviceDropdown = [
  {
    id: 1,
    title: "SUPPLIER RESOURCES",
    path: "./supplier",
    cName: "submenu-item",
  },
  {
    id: 2,
    title: "PRODUCT SUPPLIERS",
    path: "./prosupplier",
    cName: "submenu-item",
  },
];


